<template>
    <div class="drop-menu" :style="{border: border, background: bgColor}" @click="clickEvent">
        <span >
            {{dropMenuMsg}}
            <img :src="arrowImg" :style="{transform: 'rotate('+arrowRotate+'deg)'}" />
        </span>
        <slot v-if="show"></slot>
            <!-- <slot></slot> -->
    </div>
</template>
<script>
export default {
    name: 'DropMenu',
    data () {
        return {
            show: 0,
            arrowImg: require('../../assets/img/icon/arrow_down_green.svg'),
            arrowRotate: '0'
        }
    },
    props: {
        dropMenuMsg: {
            type: String,
            default: '請選擇'
        },
        border: String,
        bgColor: String,
        arrowColor: String
    },
    mounted () {
        this.setArrowColor();
        let _this = this;
        let el = _this.$el;
        document.addEventListener('click', function (e) {
            // console.log(e.target != el)
            if( el.contains(e.target) != true){
                _this.dropUp();
                _this.arrowRotate = '0'
            }
        })
    },
    methods: {
        dropDown: function () {
            this.show = 1;
        },
        dropUp: function () {
            this.show = 0;
        },
        clickEvent: function () {
            let tag = event.target.tagName;
            // console.log(tag)
            if( tag == 'LI' ){
                this.dropUp();
                this.arrowRotate = '0'
            }else if( tag == 'DIV' || tag == 'SPAN' || tag == 'IMG'){
                this.dropDown()
                this.arrowRotate = '180'
            }
        },
        setArrowColor: function () {
            if( this.arrowColor == 'white' ){
                this.arrowImg = require('../../assets/img/icon/arrow_down_white.svg');
            }else if( this.arroWColor == 'green' ){
                this.arrowImg = require('../../assets/img/icon/arrow_down_green.svg');
            }
        },
    }
}
</script>
<style   lang="scss">
    .drop-menu{
        position: relative;
        border: 1px solid #ccc;
        border-radius: 5px;
        cursor: pointer;
        span{
            display: block;
            height: 100%;
            display: flex;
            align-items: center;
            color: #fff;
        }
        ul{
            position: absolute;
            width: 100%;
            padding: 4px 0;
            border-radius: 4px;
            // background: #000;
            background: #f0f0f0;
            top: 47px;
            border: solid 1px #eeeeee;
            box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
            z-index: 6;
            li{
                position: relative;
                display: flex;
                align-items: center;
                padding: 12px 16px;
                a{
                    display: flex;
                    align-items: center;
                }
            }
            li:hover{
                background: #fff;
            }
        }
    }

    
</style>


// WEBPACK FOOTER //
// src/components/widge/DropMenu.vue